// store/duck/avaliacao.js

// Types
export const CRIAR_AVALIACAO_REQUEST = 'CRIAR_AVALIACAO_REQUEST';
export const CRIAR_AVALIACAO_SUCCESS = 'CRIAR_AVALIACAO_SUCCESS';
export const CRIAR_AVALIACAO_FAILURE = 'CRIAR_AVALIACAO_FAILURE';

export const BUSCAR_AVALIACAO_REQUEST = 'BUSCAR_AVALIACAO_REQUEST';
export const BUSCAR_AVALIACAO_SUCCESS = 'BUSCAR_AVALIACAO_SUCCESS';
export const BUSCAR_AVALIACAO_FAILURE = 'BUSCAR_AVALIACAO_FAILURE';

// Actions
export const criarAvaliacaoRequest = (payload) => ({
  type: CRIAR_AVALIACAO_REQUEST,
  payload,
});

export const criarAvaliacaoSuccess = ({ docRefAvaliacao, idAvaliacao, device }) => ({
  type: CRIAR_AVALIACAO_SUCCESS,
  payload: { docRefAvaliacao, idAvaliacao, device },
});


export const criarAvaliacaoFailure = (error) => ({
  type: CRIAR_AVALIACAO_FAILURE,
  payload: error,
});

export const buscarAvaliacaoRequest = (id) => ({
  type: BUSCAR_AVALIACAO_REQUEST,
  payload: id,
});

export const buscarAvaliacaoSuccess = (data) => ({
  type: BUSCAR_AVALIACAO_SUCCESS,
  payload: data,
});

export const buscarAvaliacaoFailure = (error) => ({
  type: BUSCAR_AVALIACAO_FAILURE,
  payload: error,
});

// Reducer
const initialState = {
  avaliacaoId: null,
  device: null,
  loading: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CRIAR_AVALIACAO_REQUEST:
    case BUSCAR_AVALIACAO_REQUEST:
      return { ...state, loading: true, error: null };

      case CRIAR_AVALIACAO_SUCCESS:
        return {
          ...state,
          avaliacaoId: {
            docRefAvaliacao: action.payload.docRefAvaliacao,
            idAvaliacao: action.payload.idAvaliacao,
          },
          device: action.payload.device || null,
          loading: false,
        };
        
      

    case BUSCAR_AVALIACAO_SUCCESS:
      return { ...state, device: action.payload, loading: false };

    case CRIAR_AVALIACAO_FAILURE:
    case BUSCAR_AVALIACAO_FAILURE:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
}    